import {
  CheckCircleOutlineRoundedIcon,
  CancelOutlinedIcon,
  ErrorOutlineOutlinedIcon,
  Text,
  Flex,
} from '@shared/components';

type ReviewResult = 'approved' | 'rejected' | 'partially-approved';

export interface ReviewResultBadgeProps {
  result: ReviewResult;
}

const RESULT_ICON = {
  approved: CheckCircleOutlineRoundedIcon,
  rejected: CancelOutlinedIcon,
  'partially-approved': ErrorOutlineOutlinedIcon,
} as const;

const RESULT_COLOR = {
  approved: 'success',
  rejected: 'error',
  'partially-approved': 'warning',
} as const;

const RESULT_LABEL = {
  approved: 'เห็นด้วย',
  rejected: 'ไม่เห็นด้วย',
  'partially-approved': 'เห็นด้วยบางส่วน',
} as const;

export default function ReviewResultBadge(props: Readonly<ReviewResultBadgeProps>) {
  const { result } = props;
  const IconComponent = RESULT_ICON[result];

  return (
    <Flex
      sx={(theme) => ({
        alignItems: 'center',
        gap: theme.spacing(1),
        pl: theme.spacing(2.5),
        pr: theme.spacing(3),
        py: theme.spacing(0.5),
        borderRadius: theme.shape.rounded(7),
        border: '1px solid',
        borderColor: theme.palette[RESULT_COLOR[result]].main,
        bgcolor: theme.palette[RESULT_COLOR[result]].lighter,
      })}
    >
      <IconComponent color={RESULT_COLOR[result]} sx={{ fontSize: '16px' }} />
      <Text variant='body2Semibold' color={RESULT_COLOR[result]}>
        {RESULT_LABEL[result]}
      </Text>
    </Flex>
  );
}
